import styled from 'styled-components';

export const AddAssetDrawerContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme: { token } }) => token.padding}px 0;
  gap: ${({ theme: { token } }) => token.marginLG}px;
  width: 100%;
  height: calc(100% - 50px);
  overflow: auto;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .body-title {
    margin-left: ${({ theme: { token } }) => token.margin}px;
    font-size: ${({ theme: { token } }) => token.fontSizeHeading4}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  }
`;
